import React, { Component } from 'react';
import { observer } from 'mobx-react';
import ContentStore from 'stores/Content.store';

import { Container, Title } from 'common/components/Layout/Layout';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import styles from './TermsOfUse.module.scss';

@observer
export default class TermsOfUse extends Component {
  render() {
    if (!ContentStore.isLoaded) {
      return null;
    }

    const { content } = ContentStore;

    return (
      <div>
        <InjectMetaTags {...content.TermsOfUseSEO} />
        <Container>
          <Title title={content.TermsOfUseHeader} />
          <div
            className={styles.Content}
            dangerouslySetInnerHTML={{ __html: content.TermsOfUseText }}
          />
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/TermsOfUse/TermsOfUse.js